import {URL_PAYMENTS, URL_PROFILE} from "../../../properties";
import {getMoneyString} from "../../../utils/formatUtils";
import {getFromLocalStorage} from "../../../utils/localStorageUtils";

export const getHeaderPartnerName = (isPartnerPage, partnerBalance) => {
    return isPartnerPage && partnerBalance
        ? partnerBalance.email + " | " + partnerBalance.dominicPartnerId
        : getFromLocalStorage("user")?.login;
};

export const getHeaderBalance = (partnerBalance) => {
    return partnerBalance ? getMoneyString(partnerBalance.balance) + "р" : "0р";
};

export const getUnreadNewsItemsAmount = (news) => {
    return news ? news.filter(item => item.isNew).length : 0;
};

export const getHeaderPaymentsUrl = (isAdminAsPartner, partnerId) => {
    return isAdminAsPartner
        ? URL_PAYMENTS + "?partnerId=" + partnerId
        : URL_PAYMENTS;
};

export const getHeaderProfileUrl = (partnerId) => {
    return URL_PROFILE + (partnerId ? "?partnerId=" + partnerId : "");
};
